import type { Parameters, RequestBody, Response } from '../../../../../types/typeHelper';
import { useApiClient } from '../../client';

export enum FeatureFlagsClientQueryKeys {
  GET_FEATURE_FLAGS = 'GET_FEATURE_FLAGS',
  UPDATE_FEATURE_FLAGS = 'UPDATE_FEATURE_FLAGS',
}

export type FetchFeatureFlagsResponseData = Response<'/admin/feature-flags', 'get'>;

export const getGetFeatureFlagsQueryKey = () => [FeatureFlagsClientQueryKeys.GET_FEATURE_FLAGS];

export const useFeatureFlagsApiHelper = () => {
  const client = useApiClient();
  return {
    updateFeatureFlags: async ({
      body,
      path,
    }: {
      body: RequestBody<'/admin/feature-flags/{feature_flag_id}', 'patch'>;
      path: Parameters<'/admin/feature-flags/{feature_flag_id}', 'patch'>['path'];
    }) => {
      return client.PATCH('/admin/feature-flags/{feature_flag_id}', {
        body,
        params: {
          path,
        },
      });
    },
  };
};
